module.exports = __webpack_public_path__ + "img/tag_tj.02ea323d.png";